import { IButtonClassGroup, ButtonClassGroup } from "./ButtonClassGroup.types";
import { IButtonIconClassGroup, ButtonIconClassGroup } from "./ButtonIconClassGroup.types";
import { IChipClassGroup, ChipClassGroup } from "./ChipClassGroup.types";
import { FormControlClassGroup } from "./FormControlClassGroup";
import { IInputClassGroup, InputClassGroup } from "./InputClassGroup.types";

export { InputClassGroup, IInputClassGroup } from "./InputClassGroup.types";
export * from "./ButtonClassGroup.types";

export type IComponentClassGroup = IInputClassGroup & IButtonClassGroup & IButtonIconClassGroup & IChipClassGroup;
export type ComponentClassNames = keyof IComponentClassGroup;
export const ComponentClassGroup = {
  ...InputClassGroup,
  ...ButtonClassGroup,
  ...ButtonIconClassGroup,
  ...ChipClassGroup,
  ...FormControlClassGroup,
};
